import {Grid} from "@material-ui/core"
import {AvailableTests} from "./available-tests"
import {LastTests} from "./last-tests"

export function StudentQuizDashboard() {
  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <AvailableTests />
      </Grid>
      <Grid item>
        <LastTests />
      </Grid>
    </Grid>
  )
}
